
import { defineComponent } from 'vue'

import Tabs from '@/common/components/UI/Tabs/index.vue'

// types
import { TabT } from '@/core/types/components.types'

export default defineComponent({
    components: {
        tabs: Tabs,
    },
    setup() {
        const tabs: TabT[] = [
            { id: 1, name: 'ПВЗ', path: '/pvz' },
            { id: 2, name: 'Накладные', path: '/pvz/invoices' },
        ]

        return { tabs }
    },
})
